import { render } from "./WelcomeDashboard.vue?vue&type=template&id=3343c3ac"
import script from "./WelcomeDashboard.vue?vue&type=script&lang=js"
export * from "./WelcomeDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__